export default "__VITE_ASSET__4929e499__"